import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FiveStarBlack } from '../../assets/images/icons/five_stars_black.svg';
import styles from './StarRating.module.scss';

export default function StarRating() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <FiveStarBlack className={styles.stars} />
      <span className={styles.rating}>{'4.7'}</span>
      <span className={styles.reviews}>{t('star_rating_reviews_count')}</span>
    </div>
  );
}
